export enum QueueIdEnum {
  All = 'all',
  AnsweredByMe = 'answered-by-me',
  AnsweredByOthers = 'answered-by-others',
  ArchivedByMe = 'archived-by-me',
  ArchivedByOthers = 'archived-by-others',
  AssignedToOthers = 'assigned-to-others',
  AssignedToYou = 'assigned-to-you',
  HelpRequested = 'help-requested',
  OnHoldByOthers = 'on-hold-by-others',
  Received = 'received',
  Default = Received,
}
